import { CustomError } from './custom_error';
function combineStacks(myStack, oldStack) {
    const stackSplit = oldStack === null || oldStack === void 0 ? void 0 : oldStack.split('\n');
    let causedByText = stackSplit === null || stackSplit === void 0 ? void 0 : stackSplit.shift();
    if (causedByText !== undefined) {
        causedByText = causedByText.replace(/ \(/g, ' :('); // escape ' (' with ' :('
    }
    return `${myStack}\nat Caused By: ${causedByText}:0:0\n${stackSplit === null || stackSplit === void 0 ? void 0 : stackSplit.join('\n')}`;
}
export class NestedError extends CustomError {
    constructor(message, error, opts = {}) {
        super(message, opts);
        this.cause = error instanceof Error ? error : new Error(`${error}`);
        Object.setPrototypeOf(this, NestedError.prototype);
        this.stack = combineStacks(this.stack, error instanceof Error ? error.stack : `${error}`);
    }
    toString() {
        const cause = this.cause !== undefined ? this.cause.toString() : '';
        return `${super.toString()}. Caused By: ${cause}`;
    }
}
//# sourceMappingURL=nested_error.js.map